const ADD_GLOBAL_DELIVERY_PREFERENCES_TO_SESSION_STORAGE =
  'globalDeliveryPreferences/setAsConfirmed';
const GLOBAL_DELIVERY_PREFERENCES_SESSION_STORAGE_KEY = 'eDeliveryPreferences';

export {
  ADD_GLOBAL_DELIVERY_PREFERENCES_TO_SESSION_STORAGE,
  GLOBAL_DELIVERY_PREFERENCES_SESSION_STORAGE_KEY,
};
